import { useTranslation } from "react-i18next";
import { HoverPopover } from "@/components/ui";
import { statusDotClass } from "@/lib/statusDot";
import { cn } from "@/lib/utils";

export function AdminUserStatusDot({ isActive }: { isActive: boolean }) {
  const { t } = useTranslation("adminUsers");
  const label = isActive
    ? t("list.statusTooltipActive")
    : t("list.statusTooltipInactive");

  return (
    <HoverPopover content={label} placement="above">
      <span
        className="mr-2 inline-flex cursor-default items-center justify-center rounded-full p-1.5"
        aria-label={label}
        onClick={(event) => event.stopPropagation()}
      >
        <span
          className={cn("h-2.5 w-2.5 rounded-full", statusDotClass(isActive))}
          aria-hidden
        />
      </span>
    </HoverPopover>
  );
}
